import theme from '../styledTheme'

export const onMobile = () => `@media screen and (max-width: ${theme.rcPhonePoint})`

export const onTablet = () => `@media screen and (max-width: ${theme.rcTabletPoint})`

export const onDesktop = () => `@media screen and (min-width: ${theme.rcTabletPoint})`
